import React from "react";
import PropTypes from "prop-types";
import { Overlay } from "components";
import { normalize } from 'utilities';
import styled from "react-emotion";

const propTypes = {
  placeholder: PropTypes.string.isRequired,
  initialValue: PropTypes.any,
  name: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  selectedClass: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};

class Select extends React.Component {
  select = null;
  state = {
    value: this.props.initialValue || null,
    open: false,
    allValues: normalize(),
  };
  getChildContext() {
    return {
      selectGroup: {
        onChange: this.handleChange,
        selectedValue: this.state.value,
        selectedClass: this.props.selectedClass || "",
        close: this.handleClose,
        hasImg: this.props.img !== undefined
      }
    };
  }

  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpen = () => {
    this.setState({ open: true });
  };
  handleChange = (value, label) => {
    const { onChange, name } = this.props;
    this.setState({ open: false, value, label });
    const event = new Event('change');
    this.select.dispatchEvent(event);
    onChange({ value, name, label }, event);
  };

  componentDidMount() {
    const { children } = this.props;
    const values = React.Children.map(children, child => ({ value: child.props.value, label: child.props.label }));
    this.setState({ allValues: normalize(values, 'value')});
  }

  render() {
    const { name, children, img, placeholder } = this.props;
    const { allValues, value } = this.state;
    const label = allValues.elements[value] ? allValues.elements[value].label : placeholder;
    
    return (
      <div className="form-field">
        {img && (
          <span className="select-type-icon">
            <img src={img} alt="" />
          </span>
        )}
        <div className="select-wrapper">
          <select ref={node => this.select = node} name={name} value={value || ""}>
            <option value={""}></option>
            {allValues.ids.map(id=> (
              <option value={id} key={id}></option>
            ))}
          </select>
          <div className="select-field" onClick={this.handleOpen}>
            <Label img={img !== undefined}>{label}</Label>
          </div>
          {this.state.open && (
            <Overlay close={this.handleClose}>
              <div className="select-option-list">{children}</div>
            </Overlay>
          )}
          <span className="error-ms" />
        </div>
      </div>
    );
  }
}
Select.childContextTypes = {
  selectGroup: PropTypes.object
};
Select.propTypes = propTypes;
export default Select;

const Label = styled("div")`
  ${props => props.img ? `
    margin-left: 33px;
  ` : null};
`;


// WEBPACK FOOTER //
// ./src/components/form/select/Select.jsx